import { render, staticRenderFns } from "./aufgabe-details-modal.vue?vue&type=template&id=174ef01b&scoped=true"
import script from "./aufgabe-details-modal.vue?vue&type=script&lang=js"
export * from "./aufgabe-details-modal.vue?vue&type=script&lang=js"
import style0 from "./aufgabe-details-modal.vue?vue&type=style&index=0&id=174ef01b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ef01b",
  null
  
)

export default component.exports